import client from '@/api/client'
import { AxiosResponse } from 'axios'
import { Response } from '@/api/PaginatedResponse'
import { CommonCountryResponseDto, CommonCountryStateResponseDto } from '@/dto/common/Country/Response'

export function getCountries(
): Promise<AxiosResponse<Response<CommonCountryResponseDto>>> {
  return client.get(`common/countries`)
}
export function getCountryStates(
  countryCode: string
): Promise<AxiosResponse<CommonCountryStateResponseDto>> {
  return client.get(`common/addressing/countries/${countryCode}/administrative-areas`)
}

